import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { plainTextToCourseDescriptionHtml } from '../utils/courseDescriptionHtml';
import './CourseDescriptionContent.css';

function CourseDescriptionContent({
  html,
  className,
  clamped,
  id,
}) {
  const sanitizedHtml = useMemo(() => plainTextToCourseDescriptionHtml(html), [html]);

  if (sanitizedHtml === '') {
    return null;
  }

  const classNames = [
    'course-description-content',
    className,
    clamped ? 'is-clamped' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      id={id}
      className={classNames}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
}

CourseDescriptionContent.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string,
  clamped: PropTypes.bool,
  id: PropTypes.string,
};

CourseDescriptionContent.defaultProps = {
  html: '',
  className: '',
  clamped: false,
  id: undefined,
};

export default CourseDescriptionContent;
